import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

// A small confirmation dialog that sits above any other modal, so confirming inside the History modal works.
const DocumentConfirmModal = ({ title, message, confirmLabel = "Confirm", tone = "primary", busy = false, onConfirm, onCancel }) => {
    const confirmRef = useRef(null);

    useEffect(() => {
        confirmRef.current?.focus();
        const onKey = (e) => { if (e.key === "Escape" && !busy) { e.stopPropagation(); onCancel?.(); } };
        document.addEventListener("keydown", onKey, true);
        return () => document.removeEventListener("keydown", onKey, true);
    }, [busy, onCancel]);

    return createPortal(
        <div
            style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
            onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) onCancel?.(); }}
        >
            <div className="bg-white rounded-4 shadow p-4" role="alertdialog" aria-modal="true" aria-labelledby="document-confirm-title" aria-describedby="document-confirm-message" style={{ width: "100%", maxWidth: 440 }}>
                <h5 id="document-confirm-title" className="fw-semibold mb-2">{title}</h5>
                <p id="document-confirm-message" className="text-muted mb-4">{message}</p>
                <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-outline-secondary" disabled={busy} onClick={onCancel}>Cancel</button>
                    <button type="button" ref={confirmRef} className={`btn btn-${tone}`} disabled={busy} onClick={onConfirm}>{busy ? "Please wait..." : confirmLabel}</button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default DocumentConfirmModal;
